module.exports = __webpack_public_path__ + "static/media/star.b5659058.svg";